import './TransportModesPanel.scss'

import { HDSIcon } from '@here/hds-react-components'
import classNames from 'classnames'
import React, { useState } from 'react'

export enum TransportModesPanelMode {
  PublicTransport = 'multimodal',
  Car = 'driving',
  Taxi = 'taxi',
  Bike = 'bicycle',
  Motorcycle = 'motorcycle',
  Walk = 'walking',
  Unknown = 'unknown',
}

export interface TransportPanelOption {
  title: string
  mode: TransportModesPanelMode
}

export interface TransportModesPanelProps {
  selectedOption?: TransportModesPanelMode
  options: TransportPanelOption[]
  onClick: (mode: TransportModesPanelMode) => void
  isRouteFetching: boolean
}

export function TransportModesPanel({
  selectedOption,
  options,
  onClick,
  isRouteFetching,
}: TransportModesPanelProps): JSX.Element {
  const [selectedFilter, setSelectedFilter] = useState(selectedOption)
  const handleFilterButtonClick = (option: TransportPanelOption): void => {
    if (!isRouteFetching) {
      setSelectedFilter(option.mode)
      onClick(option.mode)
    }
  }
  return (
    <div className="TransportModesPanel__container">
      <div className="TransportModesPanel__buttons-container">
        {options.map((option, index) => {
          return (
            <div
              key={`FilterPanelButton${index}`}
              className={classNames('TransportModesPanel__button', {
                'TransportModesPanel__button--active': option.mode === selectedFilter,
                'TransportModesPanel__button--disabled': isRouteFetching,
              })}
              onClick={() => handleFilterButtonClick(option)}
            >
              <HDSIcon
                name={option.mode}
                category="travel-transport-tracking"
                style={
                  {
                    '--hds-icon-color':
                      option.mode === selectedFilter
                        ? 'var(--hds-background-primary)'
                        : 'var(--hds-foreground-secondary)',
                  } as React.CSSProperties
                }
                iconStyle="solid"
                size="16px"
              />
            </div>
          )
        })}
      </div>
      <div className="TransportModesPanel__settings-button-container">
        <HDSIcon name="settings" iconStyle="solid" size="16" />
      </div>
    </div>
  )
}
